import listings from 'BomdisoftComponents/store-badges/listings.json';

export type MobileAppProduct = 'clepit' | 'gamblish' | 'njangy' | 'pieleaf' | 'prodantix' | 'workadabra';
export type MobileStore = 'appStore' | 'googlePlay';
export type StoreListings = Record<MobileStore, string | null>;

export const MOBILE_APP_PRODUCTS: readonly MobileAppProduct[] = ['clepit', 'gamblish', 'njangy', 'pieleaf', 'prodantix', 'workadabra'];
export const MOBILE_STORES: readonly MobileStore[] = ['appStore', 'googlePlay'];
export const STORE_LISTINGS: Record<MobileAppProduct, StoreListings> = listings;

export const listingFor = (product: MobileAppProduct, store: MobileStore): string | null => STORE_LISTINGS[product][store];
